import React, { useState } from 'react'
import image1 from '../assets/images/edges-design.jpg'
import image2 from '../assets/images/edges-design1.jpg'
import image3 from '../assets/images/edges-design10.jpg'
import image4 from '../assets/images/edges-design12.jpg'
import Sectionbreak from './Sectionbreak'

const galleryData = {
  Design: [
    image1,
    image2,
    image3,
  ],
  Construction: [
    image1,
    image2,
    image3,
    image4
  ],
  'Real Estate': [
    image1,
    image3,
    image4
  ],
  Architecture: [
    image3,
    image4
  ],
}

const Gallery = () => {
  const tabs = Object.keys(galleryData)
  const [activeTab, setActiveTab] = useState(tabs[0])

  return (
    <section className="py-16 bg-gray-50">
        <Sectionbreak
        title='Our Work'
        highlight='Gallery'
        description=''
        />
      <div className="max-w-6xl mx-auto px-4">
        {/* Tabs */}
        <div className="flex justify-center mb-8 flex-wrap gap-4">
          {tabs.map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`px-4 py-2 text-sm font-medium transition ${
                activeTab === tab
                  ? 'bg-teal-600 text-white'
                  : 'bg-gray-200 text-gray-700 hover:bg-teal-100'
              }`}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {galleryData[activeTab].map((src, index) => (
            <div
              key={index}
              className="overflow-hidden rounded-md shadow-sm hover:shadow-md transition"
            >
              <img
                src={src}
                alt={`${activeTab} ${index + 1}`}
                className="w-full h-64 object-cover hover:scale-105 transition-transform duration-300"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Gallery
